// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__kxaJX","button":"Pagination_button__86qpo","separator":"Pagination_separator__WoxSG"};